import React, {useEffect, useState} from 'react';
import { Box, Flex, Text, Heading, Separator, Badge, IconButton, Button } from '@radix-ui/themes';
import { DateTime } from 'luxon';
import {useSelector, useDispatch} from 'react-redux';
import { updateTeacherCourses, updateTeacherPeriods } from '../../../redux/slices/teacherAccountSlice';
import { Icon } from '@radix-ui/themes/dist/esm/components/callout.js';
import { Pencil1Icon, TrashIcon } from '@radix-ui/react-icons';
import { useConfirmDialog } from '../../../contexts/confirmDialog';
import { set } from 'lodash';
import {periodService} from '../../../services/teacher/periodService';
import { toast } from 'react-toastify';

const ViewPeriod = ({ period, onCancel }) => {
    const dispatch = useDispatch();
    const courses = useSelector(state => state.teacherAccount.courses);
    console.log('period::', period);
    console.log('courses::', courses);
    // const teachingPlans = useSelector(state => state.teacherAccount.teachingPlans);
    const [plannedCourses, setPlannedCourses] = useState([]);

    const periods = useSelector(state => state.teacherAccount.periods);
    const {showConfirmDialog} = useConfirmDialog();
    if (!period) {
        return <Text>No period data available.</Text>;
    }

    const { id, title, start_date, end_date, status } = period;

    useEffect(() => {
        const planned_courses = courses.filter(course => course.active_teaching_plan?.period_id === period.id) || [];
        console.log('plannedCourses::', planned_courses);
        setPlannedCourses(planned_courses);
    },[courses, period]);

    const handleDeletePeriod = (id) => {
        showConfirmDialog(
        <Box>
            <Text as="p" size="1" weight="bold" mb="4">You do not need to delete your periods</Text>
            <Text as="p" size="1" mb="4">This action will delete everything related to this period including all <Text style={{color: 'var(--accent-9)'}} as="span" weight="bold">teaching plans, quizzes</Text> and <Text style={{color: 'var(--accent-9)'}} as="span" weight="bold">reports</Text></Text>
            <Text as="p" size="1">The only reason to delete a period is if you created it by accident</Text>
        </Box>
        , () => deletePeriod(),
            {
                'title': 'Delete Period',
                'confirmText': 'Delete',
                'cancelText': 'Cancel',
                'confirmColor': 'red',
            }
        );
    }

    const deletePeriod = async () => {
        try {
            const response = await periodService.deletePeriod(id);
            // if (response.status === 200) {
                // console.log('Period deleted successfully');
                // toast.success('Period deleted successfully');
                const updatedCourses = courses.map(course => {
                    if (course.active_teaching_plan?.period_id === id) {
                        return { ...course, active_teaching_plan: null };
                    }
                    return course;
                });
                dispatch(updateTeacherCourses(updatedCourses));
                const updatedPeriods = periods.filter(period => period.id !== id);
                dispatch(updateTeacherPeriods(updatedPeriods));
                toast.success('Period deleted successfully');
                onCancel?.();
            // } else {
            //     console.error('Failed to delete period:', response);
            // }
        } catch (error) {
            console.error('Error deleting teaching plan:', error);
            toast.error('Error deleting teaching plan');
        }
    }

    const handleFinalizePeriod = async () => {
        showConfirmDialog(
            <Box>
                <Text as="p" size="1" mb="4">Finalizing this period means students will no longer see quizzes from any teaching plan under this period. Reports will be generated for this period.</Text>
                <Text as="p" size="1" weight="bold">This action cannot be undone</Text>
            </Box>
            , () => finalizePeriod(),
            {
                'title': 'Finalize Period',
                'confirmText': 'Finalize',
                'cancelText': 'Cancel',
                'confirmColor': 'green',
            }
        );
    }

    const finalizePeriod = async () => {
        try {
            const response = await periodService.finalizePeriod(id);
            if (response.status === 200) {
                console.log('Period finalized successfully');
                toast.success('Period finalized successfully');
                const updatedCourses = courses.map(course => {
                    if (course.active_teaching_plan?.period_id === id) {
                        return { ...course, active_teaching_plan: null };
                    }
                    return course;
                });
                dispatch(updateTeacherCourses(updatedCourses));
                const updatedPeriods = periods.map(period => {
                    if (period.id === id) {
                        return { ...period, status: 'completed' };
                    }
                    return period;
                });
                dispatch(updateTeacherPeriods(updatedPeriods));
            } else {
                console.error('Failed to finalize period:', response);
            }
        } catch (error) {
            console.error('Error finalizing period:', error);
            toast.error('Error finalizing period');
        }
    }

    const handlePlan = (id) => {
        showConfirmDialog(
            <Box>
                <Text as="p" size="1" mb="4">Deleting this teaching plan will delete all quizzes and reports related to this plan</Text>
                <Text as="p" size="1" weight="bold">This action cannot be undone</Text>
            </Box>
            , () => deletePlan(id),
            {
                'title': 'Delete Teaching Plan',
                'confirmText': 'Delete',
                'cancelText': 'Cancel',
                'confirmColor': 'red',
            }
        );
    }
    const deletePlan = async (id) => {
        try {
            const response = await periodService.deletePeriod(id);
            if (response.status === 200) {
                console.log('Teaching plan deleted successfully');
                toast.success('Teaching plan deleted successfully');
                const updatedCourses = courses.map(course => {
                    if (course.active_teaching_plan?.period_id === id) {
                        return { ...course, active_teaching_plan: null };
                    }
                    return course;
                });
                dispatch(updateTeacherCourses(updatedCourses));
                const updatedPeriods = periods.filter(period => period.id !== id);
                dispatch(updateTeacherPeriods(updatedPeriods));
                onCancel?.();
            } else {
                console.error('Failed to delete teaching plan:', response);
            }
        } catch (error) {
            console.error('Error deleting teaching plan:', error);
            toast.error('Error deleting teaching plan');
        }
    }

    

    const renderButtons = () => {
        if (status === 'active') {
            if (DateTime.now() > DateTime.fromISO(end_date)) {
                return (
                    <Button variant="solid" size="small" onClick={() => handleFinalizePeriod()}>Finalize</Button>
                );
            } else {
                return (
                    <Flex gap="2">
                        <IconButton variant="soft" size="small" onClick={() => {}}><Pencil1Icon /></IconButton>
                        <IconButton variant="soft" size="small" onClick={() => handleDeletePeriod(id)}><TrashIcon /></IconButton>
                    </Flex>
                );
            }
            
        }
        if (status === 'completed') {
            return (
                // <Flex gap="2">
                //     <Button variant="secondary" size="small" onClick={() => {}}>View Report</Button>
                //     <Button variant="secondary" size="small" onClick={() => {}}>Archive</Button>
                // </Flex>
                null
            );
        }
        return (
            // <Flex gap="2">
            //     <Button variant="secondary" size="small" onClick={() => {}}>Edit</Button>
            //     <Button variant="secondary" size="small" onClick={() => {}}>Delete</Button>
            // </Flex>
            null
        );
    }

    return (
        <Box>
            <Flex gap="2" align="center" justify="between" mb="4">
                <Flex direction="column" gap="1">
                    <Text size="2" weight="bold">{title}</Text>
                    <Text size="1">Start Date: {DateTime.fromISO(start_date).toLocaleString(DateTime.DATE_MED)}</Text>
                    <Text size="1">End Date: {DateTime.fromISO(end_date).toLocaleString(DateTime.DATE_MED)}</Text>
                </Flex>
                <Flex direction="column" align="end" gap="1">
                    <Badge color="green">{status}</Badge>
                    {renderButtons()}
                </Flex>
            </Flex>
            <Separator size="4" my="4" />
            <Heading size="2" mb="3">Teaching Plans</Heading>
            {plannedCourses?.length > 0 ? (
                <Box>
                    {plannedCourses.map((course, index) => (
                        <Flex key={index} mb="2" justify="between" align="center" className="cursor-pointer hidden-trigger">
                            <Text size="1">{course.level.label} | {course.subject.name}</Text>
                            <Flex gap="2" className="hidden-content">
                                <IconButton variant="outline" size="small" onClick={() => {}}><Pencil1Icon /></IconButton>
                                <IconButton variant="outline" size="small" onClick={() => handlePlan(id)}><TrashIcon /></IconButton>
                            </Flex>
                        </Flex>
                    ))}
                </Box>
            ) : (
                <Text>No teaching plans available.</Text>
            )}
        </Box>
    );
};

export default ViewPeriod;
